import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../UICommon';

export const DesktopButtonWrapper = styled.div<{ maxWidth?: number; marginTop?: number; marginleft?: number }>`
  margin: auto;
  margin-top: ${({ marginTop }) => (marginTop === undefined ? `48px` : `${marginTop}px`)};
  margin-left: ${({ marginleft }) => (marginleft === undefined ? `auto` : `${marginleft}px`)};
  display: block;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '100%')};

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const BackArrowImg = styled.img`
  cursor: pointer;
  height: 24px;
  margin-bottom: 20px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 4px;
  }
`;

export const Section = styled.div<{ centered?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${getColor('GRAY_50')};
  margin-bottom: 8px;
  text-align: center;
`;

export const StickyMobileButtonWrapperHeight = 90;

export const StickyMobileButtonWrapper = styled.div<{ hideBorder?: boolean }>`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    height: ${StickyMobileButtonWrapperHeight}px;
    width: 100%;
    background-color: ${getColor('DARK_CREAM')};
    border-top: ${({ hideBorder }) => (hideBorder ? 'none' : `1px solid ${getColor('GRAY_20')}`)};
    padding: 16px 24px;
  }
`;

export const SkipText = styled.span`
  color: ${getColor('GRAY_50')};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

export const HeaderContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;
